import React from "react";
import {EclubForm} from "../Components";

export default function EclubJoin() {
    return(

<EclubForm/>
    
    );
}